import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect, useRef, useState } from 'react'
import { Spinner } from '@rentflowdev/ui'
import { exchangeCode, redirectToAuth } from '@/lib/auth'

export const Route = createFileRoute('/callback')({
	component: CallbackPage,
})

function CallbackPage() {
	const navigate = useNavigate()
	const [error, setError] = useState<string | null>(null)
	const called = useRef(false)

	useEffect(() => {
		if (called.current) return
		called.current = true

		const params = new URLSearchParams(window.location.search)
		const code = params.get('code')
		const state = params.get('state')

		if (!code || !state) {
			void redirectToAuth()
			return
		}

		exchangeCode(code, state).then((success) => {
			if (success) {
				void navigate({ to: '/' })
			} else {
				setError('Не удалось завершить авторизацию. Попробуйте снова.')
			}
		})
	}, [navigate])

	if (error) {
		return (
			<div className="flex flex-col items-center justify-center h-screen gap-4 bg-(--color-background)">
				<p className="text-sm text-(--color-muted-foreground)">{error}</p>
				<button
					type="button"
					className="text-sm font-[500] text-(--color-brand) hover:underline"
					onClick={() => void redirectToAuth()}
				>
					Войти снова
				</button>
			</div>
		)
	}

	return (
		<div className="flex items-center justify-center h-screen bg-(--color-background)">
			<Spinner size="lg" />
		</div>
	)
}
